/**
 * Restricted (buy) program tab — mirrors IssueBuyProgramTab but queries the
 * "soc buy program" catalog type instead of "buy program".
 *
 * This tab is shown alongside the existing BOI Kit and THR tabs in
 * IssueWorkflowModal.  For the comptroller role it is the only visible tab
 * (the other tabs are hidden per the permission matrix in issue #279).
 */
import { useIssueBuyProgramTab } from './IssueBuyProgramTab';
import type { IssueBuyProgramTabOptions, IssueBuyProgramTabResult } from './IssueBuyProgramTab';
import { useIEMRestrictedProgramCatalog } from '@/hooks/queries/iem/useIEMQueries';

export type { IssueBuyProgramTabResult, IssueBuyProgramTabOptions };

/**
 * Hook for the restricted (buy) program tab in the Issue workflow.
 * Returns the same shape as useIssueBuyProgramTab; just pre-injects
 * the restricted-program catalog query hook so callers don't need to know about it.
 */
export const useIssueRestrictedProgramTab = (
  options: IssueBuyProgramTabOptions,
): IssueBuyProgramTabResult => {
  return useIssueBuyProgramTab({
    ...options,
    catalogHook: useIEMRestrictedProgramCatalog,
    variant: 'restricted',
  });
};
